/* eslint-disable react/prop-types */
import { useState } from 'react';
import { BeatLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import styles from '../../sections/contact/contact.module.scss'
import AlertComponent from '../Alert';
import Ebook from '../../assets/pdf/ebook.pdf'

const ContactForm = ({ googleSheetUrl, alertMessageError, alertMessageSuccess, ebook }) => {
    const [t] = useTranslation()
    const [loading, setLoading] = useState(false)
    const [response, setResponse] = useState(null)
    const [error, setError] = useState(null)

    const onSubmit = (e) => {
      setLoading(true)
      const formElement = document.querySelector('#form')
      e.preventDefault()
      const formatData = new FormData(formElement)
     fetch(`${googleSheetUrl}`,
        { 
          method: 'POST', 
          body: formatData
        }
     )
     .then(response => setResponse(response))
     .catch(error => setError(error))
     .finally(() => setLoading(false))   
    }
  
    if(error) return <AlertComponent type='error' message={alertMessageError} />
    if(loading) return <BeatLoader style={{display:'flex', justifyContent: 'center', alignItems:'center', height: '100%'}} color="#17bebb" /> 
    if(response) {
      return (
        <div style={{ padding: 20}}>
          <AlertComponent type='success' message={alertMessageSuccess} />
          {ebook ? <a href={Ebook} style={{display:'flex', justifyContent: 'center', alignItems:'center', marginTop: 30 }} download>Descarga el Ebook</a>: null}
        </div>
      )
    }
    
      return (
      <form onSubmit={(e) => onSubmit(e)} className={styles.form} id='form'>
      <input placeholder={t('section.contact.form.name')} name='Name' type='text' autoComplete='true' required/>
      <input  placeholder={t('section.contact.form.email')} name='Email' type='email' autoComplete='true' required />
      <input placeholder={t('section.contact.form.position')} name='Position' type='text' autoComplete='true' />
      <input  placeholder={t('section.contact.form.school')} name='School' type='text' autoComplete='true' required />
      <input placeholder={t('section.contact.form.phone')} name='Phone' type='number' autoComplete='true' />
      <input  placeholder={t('section.contact.form.country')} name='Country' type='text' autoComplete='true' />
      <button type='submit' className={styles.button}>{t('section.contact.form.register')}</button>
      </form>
      )
  }

export default ContactForm